export { default } from './Slider.js';



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductInformation/Slider/index.js